module.exports = __webpack_public_path__ + "static/media/SalesForce-logo.95bb222c.png";